import { render, staticRenderFns } from "./ModalVideoRename.vue?vue&type=template&id=3911886e&"
import script from "./ModalVideoRename.vue?vue&type=script&lang=js&"
export * from "./ModalVideoRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports